import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('Components/HomeComponent'),
    // meta: { requiresAuth: true },
    // meta: { guestArea: true },
  },
    {
    path: '/products',
    name: 'products',
    component: () => import('Components/ProductsComponent'),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      const stripeSession = localStorage.getItem('stripeSession');
      const hasSubscription = stripeSession === 'active' || stripeSession === 'trialing';
      
      // If the user has a subscription and is NOT upgrading or downgrading, redirect to home
      if (hasSubscription && !to.query.isUpgrade && !to.query.isDowngrade) {
        next({ name: 'home' }); // Redirect to home/dashboard
      } else {
        next(); // Allow access to products page
      }
    }
  },
  // {
  //   path: '/products',
  //   name: 'products',
  //   component: () => import('Components/ProductsComponent'),
  //   meta: { requiresAuth: true },
  // },
  {
    path: '/video-link',
    name: 'video-link',
    component: () => import('Components/BroadcastLinks'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('Components/Login.vue'),
    meta: { guestArea: true },
  },
  ///old registration route
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => import('Components/Registration.vue'),
  //   meta: { guestArea: true },
  // },
  // {
  //   path: '/create-account',
  //   name: 'create-account',
  //   component: () => import('Components/CreateAccount.vue'),
  //   meta: { guestArea: true },
  // },
  {
    path: '/email-verify',
    name: 'email-verify',
    component: () => import('Components/EmailVerified.vue'),
    meta: { guestArea: true },
  },
  {
    path: '/verify-otp',
    name: 'verify-otp',
    component: () => import('Components/VerifyOtp.vue'),
    meta: { guestArea: true },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('Components/WelcomePage.vue'),
    meta: { guestArea: true },
    props: true

  },
  {
    path: '/otp',
    name: 'otp',
    component: () => import('Components/MobileOtp.vue'),
    meta: { guestArea: true },
  },
  {
    path: '/forget-password',
    name: 'ResetPassword',
    component: () => import('Components/ResetPassword.vue'),
  },
  {
    path: '/update-password',
    name: 'UpdatePassword',
    component: () => import('Components/UpdatePassword.vue'),
  },
  {
    path: '/referral-dashboard',
    name: 'ReferAndEarn',
    component: () => import('Components/ReferAndEarn'),
    meta: { requiresAuth: true },
  },
  // Google SSO callback — backend redirects here after OAuth completes
  {
    path: '/auth/google/callback',
    name: 'google-callback',
    component: () => import('Components/GoogleCallback.vue'),
    meta: { guestArea: true },
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (isLoggedIn()) {
      next()
    } else {
      next({
        name: 'login',
      })
    }
  }
  else if (to.matched.some((record) => record.meta.guestArea)) {
    if (isLoggedIn()) {
      next({
        name: 'home',
      })
    } else {
      next()
    }
  }
  else {
    next() // make sure to always call next()!
  }
})

export default router
router.beforeEach((to, from, next) => {
  console.log(`Navigating to: ${to.name}, LoggedIn: ${isLoggedIn()}`);
  next();
});

function isLoggedIn() {
  if (localStorage.getItem('state')?.length) {
    if (localStorage.getItem('stripeSession') == 'active' || localStorage.getItem('stripeSession') == 'trialing') {
      return 1
    }
    else {
      return true
    }
  }

  else {
    return 0
  }




  // return localStorage.getItem('state')?.length

}
